import React, {  } from 'react';
import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import { BwjCard } from '../../../../framework/components/bwj-layout';

interface ISteppedSectionListProps {
  rootClass?: string | undefined;
  rootStyle?: React.CSSProperties | undefined;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  };

  const stepList: IStyle = {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    counterReset: 'item',

    '& > li:last-child': {
      borderBottom: 'none',
    },
  };

  return mergeStyleSets({
    root,
    stepList,
  });
};

export const SteppedSectionList: React.FunctionComponent<ISteppedSectionListProps> = (props) => {
  const theme = getTheme();
  const styles = getStyleClasses(theme);

  return (
    <BwjCard className={styles.root}>
      <ol className={styles.stepList}>
        {props.children}
      </ol>
    </BwjCard>
  );
};
